/**
 * Never show a page from the back/forward cache to a session that is not
 * the one that rendered it (QA-UI2-01).
 *
 * Logout and login leave the document with a FULL navigation, so the
 * page the user left can sit in the browser's back/forward cache with
 * its React state (user, dashboards, numbers) still in memory. Pressing
 * Back restores that page as it was, without running a single request,
 * and shows the previous session's data to whoever is at the keyboard.
 *
 * On a restore (`pageshow` with `persisted`), the stored session is
 * compared with the one this document started with. If it changed (the
 * user logged out, or someone else logged in), the page reloads, and a
 * normal load runs the usual auth check: no session sends the browser to
 * the login page.
 */
export function installBfcacheSessionGuard(
  readToken: () => string | null,
  reload: () => void,
): () => void {
  const tokenAtLoad = readToken();
  const onPageShow = (event: PageTransitionEvent) => {
    if (!event.persisted) return;
    if (readToken() !== tokenAtLoad) reload();
  };
  window.addEventListener("pageshow", onPageShow);
  return () => window.removeEventListener("pageshow", onPageShow);
}
